/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react'

import PropTypes from 'prop-types'

import styleNames from '@pareto-engineering/bem/exports'

import { Button } from '@pareto-engineering/design-system'

import './styles.scss'

// Local Definitions

const baseClassName = styleNames.base

const componentClassName = 'time-to-read'

/**
 * This is the component description.
 */
const TimeToRead = ({
  id,
  className:userClassName,
  style,
  children,
  wordCount,
  color,
  ...props
}) => (
  <Button
    id={id}
    className={[
      baseClassName,
      componentClassName,
      userClassName,
    ]
      .filter((e) => e)
      .join(' ')}
    style={style}
    color={color}
    {...props}
    disabled
    isCompact
  >
    <span className="icon">
      C
    </span>
    {Math.ceil(wordCount / 175)}
    {' '}
    min
  </Button>
)

TimeToRead.propTypes = {
  /**
   * The HTML id for this element
   */
  id:PropTypes.string,

  /**
   * The HTML class names for this element
   */
  className:PropTypes.string,

  /**
   * The React-written, css properties for this element.
   */
  style:PropTypes.objectOf(PropTypes.string),

  /**
   *  The children JSX
   */
  children:PropTypes.node,

  /**
   * The number of words of the blog posts
   */
  wordCount:PropTypes.number.isRequired,

  /**
   * The color of the button
   */
  color:PropTypes.string,
}

TimeToRead.defaultProps = {
  color:'background-far',
}

export default TimeToRead
